$('.collect-sidebar-item.lv2>a').click(function (e) {
  e.preventDefault();
  $(this).next().slideToggle();
  // $(this).next().is(':hidden') ? $(this).find('i').removeClass('active') : $(this).find('i').addClass('active')
});


$('.collect-sidebar-select').click(function () {
  $('.collect-sidebar-list').slideToggle();
  $(this).next()
})



if (isMobile()) {
  let title = $('.collect-sidebar-item.active').attr('data-title');
  let subTitle = $('.collect-sidebar-down a.on').text();
  $('.collect-sidebar-val').val(title || subTitle)
}



if (isMobile()) {
  let width = $('.collect-compare-table').width();
  $('.collect-compare-table').width(width + 100)
}
$('.collect-toggle').click(function () {
  $(this).toggleClass('active');
  $(this).parent().prev().toggleClass('active')
})

let sideItem = document.querySelectorAll('.collect-sidebar-item');
sideItem.forEach(item => {
  if ($(item).hasClass('lv2')) {
    if ($(item).find('.collect-sidebar-down').find('a').hasClass('on')) {
      $(item).addClass('active');
    }
  }
});

let codeCopy2 = document.querySelectorAll('.collect-code-btn');
let clipboard2 = new Clipboard(codeCopy2);
clipboard2.on('success', function (e) {
  let successCon = "<div class='tb-toast'>Successfully copied!</div>"
  $('body').append(successCon);
  setTimeout(function () {
    $('.tb-toast').remove();
  }, 1000)
});


$('.collect-add-btn').click(function (e) {
  let id = $(this).data('variantid') || $(this).data('id');
  addCartFn(id)
  doFbAddToCartOp();
})


if (isMobile()) {
  var swiper = new Swiper(".navSwiper", {
    slidesPerView : 2.6,
  });
}

$('.product-compare-btn').click(function (e) {
  let id = $(this).data('variantid') || $(this).data('id');
  let formDate = {
    form_type: 'product',
    utf8: '✓',
    quantity: 1,
    id,
  }
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    data: formDate,
    dataType: 'json',
    success(res) {
      if (res) {
        getCartData();
      }
    },
    error(err) {
      let responseText = JSON.parse(err.responseText);
      if (err.status == 422) {
        let successCon = "<div class='tb-toast'>" + responseText.description + "</div>"
        $('body').append(successCon);
        setTimeout(function () {
          $('.tb-toast').remove();
        }, 1000)
      }
    }
  });
})

var collectionScooter2024Swiper = new Swiper(".collectionScooter2024Swiper", {
  slidesPerView: isMobile() ? 1.2 : 3.5,
  spaceBetween: isMobile() ? 10 : 20,
});

if (document.querySelector('.collectionScooter2024SocialSwiper')) {
  var collectionScooter2024SocialSwiper = new Swiper(".collectionScooter2024SocialSwiper", {
    slidesPerView: 1,
    spaceBetween: 16,
    autoHeight: true,
    pagination: {
      el: ".collectionScooter2024SocialPagination",
      clickable: true,
    },
  });
}

var adPageModule3Swiper = new Swiper(".adPageModule3Swiper", {
  slidesPerView: isMobile() ? 1 : 3,
  spaceBetween: isMobile() ? 10 : 80,
  pagination: {
    el: ".adPageModule3Swiper .swiper-pagination",
  },
});

var ad2024FeatureThumbsSwiper = new Swiper(".ad2024FeatureThumbsSwiper", {
  spaceBetween: 0,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
});
var ad2024FeatureSwiper = new Swiper(".ad2024FeatureSwiper", {
  spaceBetween: 0,
  thumbs: {
    swiper: ad2024FeatureThumbsSwiper,
  },
});

var ad2024ProductImageSwiper = new Swiper(".ad2024ProductImageSwiper", {
  autoplay: {
    delay: 3000,
  },
  pagination: {
    el: ".ad2024ProductImageSwiper .swiper-pagination",
  },
});

const toggleText = document.getElementById('toggleText');
const toggleImg = document.getElementById('toggleImg');
let isToggled = false;

document.querySelector('.collect-compare-toggle-btn').addEventListener('click', function() {
  const compareParams = document.querySelectorAll('.compare-params-toggle');
  compareParams.forEach(function(element) {
      element.style.display = element.style.display === 'none' ? 'table-row' : 'none';
  });
  isToggled = !isToggled;
  if (isToggled) {
    toggleText.textContent = toggleText.dataset.less;
    toggleImg.classList.add('tw-rotate-180');
  } else {
      toggleText.textContent = toggleText.dataset.more;
      toggleImg.classList.remove('tw-rotate-180');
  }
});
